import { render, staticRenderFns } from "./ResponsibleInfos.vue?vue&type=template&id=5a1ee541&scoped=true&"
import script from "./ResponsibleInfos.vue?vue&type=script&lang=js&"
export * from "./ResponsibleInfos.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleInfos.vue?vue&type=style&index=0&id=5a1ee541&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ee541",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/maplebear-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAvatar,VCard,VFlex,VIcon,VLayout})
